module.exports = __webpack_public_path__ + "static/media/pm_some_error.ea252236.svg";